import configureStore from "src/redux/configure-store";

export const store = configureStore();
